import { openApp } from "@/libs/common";
export default {
  name: "MoreMessage",
  methods: {
    jump() {
      let item = {
        code: "DSPLAT",
        isThird: "T"
      };
      openApp(this, item);
    }
  }
};